<template>
    <template v-if="amount > 0 || !zeroAmount">
        <span
            :class="[
                alignRight ? 'justify-end text-right' : '',
                stripFormatting ? '' : 'type-primary w-full',
                settings.is_sourcing_mode ? 'tabular-nums' : '',
                cellClass ? cellClass : '',
            ]"
            class="flex"
        >
          <template v-if="(superscriptDecimals && formattedParts.decimal)">
              {{ formattedParts.integer }}<span :class="decimalClass">.{{ formattedParts.decimal }}</span>
          </template>
          <template v-else>
              {{ value }}
          </template>
        </span>
    </template>
    <template v-else-if="typeof zeroAmount === 'object'">
        <component :is="zeroAmount" v-bind="props" />
    </template>
    <template v-else>
        <span v-html="typeof zeroAmount === 'function' ? zeroAmount(value) : zeroAmount" />
    </template>
</template>

<script setup>
import {useHelpers} from "@/Composables";
import {computed} from "vue";
import { useUser } from "@/Composables";

const { settings } = useUser();

const {showMeTheMoney} = useHelpers();

const props = defineProps({
    amount: {
        type: [Number, Boolean],
        required: true,
        default: 0,
    },
    zeroAmount: {
        type: [Function, Number, String, Object],
        required: false,
        default: false,
    },
    alignRight: {
        type: Boolean,
        required: false,
        default: false,
    },
    stripFormatting: {
        type: Boolean,
        required: false,
        default: false,
    },
    cellClass: {
        type: String,
        required: false,
    },
    validateAmount: {
        type: Boolean,
        required: false,
        default: false,
    },
    truncate: {
        type: Boolean,
        required: false,
        default: false,
    },
    superscriptDecimals: {
        type: Boolean,
        required: false,
        default: false,
    },
    decimalClass: {
        type: String,
        required: false,
        default: 'align-super text-2xs',
    },
});

const value = computed(() => {
    // If validation is enabled, ensure we have a valid number, default to 0 if amount is null, undefined, or not a valid number
    if (props.validateAmount) {
        const validAmount = (props.amount !== null && props.amount !== undefined && !isNaN(Number(props.amount))) 
            ? props.amount 
            : 0;
        return showMeTheMoney(validAmount, props.truncate);
    }
    
    // If validation is disabled, pass the amount as-is to showMeTheMoney
    return showMeTheMoney(props.amount, props.truncate);
});
</script>
